import { render, staticRenderFns } from "./SortedSearch.vue?vue&type=template&id=43910e5b&"
import script from "./SortedSearch.vue?vue&type=script&lang=ts&"
export * from "./SortedSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports